import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import theme from "./theme/theme";
import "./App.css";

import UnifiedDashboard from "./pages/UnifiedDashboard";
import Account from "./pages/Account";
import Register from "./pages/UserRegister";
import ResetPassword from "./pages/ResetPassword";
import NewDevice from "./pages/NewDevice";
import TermsAndConditions from "./pages/TermsAndConditions";
import Footer from "./components/Layout/Footer";
import FarmRegister from "./pages/FarmRegister";
import FarmView from "./pages/FarmView";
import { useTranslate } from "./components/Translate/TranslateContext";
import { authUser } from "./api/auth";
import { userLogout } from "./api/logout";

function App() {
  const [user, setUser] = useState({user_id: 8, account_status: "active"});
  const [loading, setLoading] = useState(true);
  const { translate } = useTranslate();

  // ---- Auth check ----
  
  useEffect(() => {
    (async () => {
      const data = await authUser();
      if (data?.success) setUser(data.user);
      setLoading(false);
    })();
  }, []);

  const handleLogout = async () => {
    await userLogout();
    setUser(null);
  };
  

  useEffect(() => {
    document.title = translate("HarvestHub");
  }, [translate]);

  if (loading) return null;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <div
        className="App"
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          backgroundColor: user
            ? "var(--color-green-strong)"
            : "var(--color-bg-dark)",
          transition: "background-color 0.3s ease",
        }}
      >
              <Routes>
                  <Route
                      path="/"
                      element={
                          user ? (
                              user.account_status === "active" ? (
                                  <Navigate to="/dashboard" replace />
                              ) : (
                                  <Navigate to="/register" replace />
                              )
                          ) : (
                              <Account onLoginSuccess={setUser} />
                          )
                      }
                  />

                  <Route
                      path="/register"
                      element={
                          user ? (
                              user.account_status === "active" ? (
                                  <Navigate to="/dashboard" replace />
                              ) : (
                                  <Register user={user} setUser={setUser} />
                              )
                          ) : (
                              <Register user={user} setUser={setUser} />
                          )
                      }
                  />

                  <Route path="/terms" element={<TermsAndConditions />} />
                  <Route path="/reset-password/*" element={<ResetPassword />} />
                  <Route path="/new-device/*" element={<NewDevice />} />
                  <Route
                      path="/farm-register"
                      element={
                          user && user.account_status === "active" ? (
                              <FarmRegister user={user} />
                          ) : (
                              <Navigate to="/" replace />
                          )
                      }
                  />

                  <Route
                      path="/farm"
                      element={
                          user && user.account_status === "active" ? (
                              <FarmView user={user} />
                          ) : (
                              <Navigate to="/" replace />
                          )
                      }
                  />
                  <Route
                      path="/dashboard/*"
                      element={
                          user && user.account_status === "active" ? (
                              <UnifiedDashboard user={user} onLogout={handleLogout} />
                          ) : (
                              <Navigate to="/" replace />
                          )
                      }
                  />
              </Routes>




        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
